import React, { Component } from 'react';

import Animator from '../Animator';
import MUTIL from '../MUTIL';
import { coalesce } from '../misc';
import I18N from '../I18N';

import { TraksConsumer } from '../traks';

class FancyNumberBlurAnim extends Component {
	constructor(props) {
		super(props);
		this.state = { u: 0 };
	}

	componentDidMount() {
		this.animator = new Animator({
			speed: 1/this.props.total_duration,
			callback: (u) => this.setState({u})
		});
	}

	componentWillUnmount() {
		if (this.animator) this.animator.kill();
	}

	render() {
		var xs = [];
		const { characters } = this.props;
		const uu = this.state.u;
		const t = uu * this.props.total_duration;
		for (var i = 0; i < characters.length; i++) {
			const t0 = i * this.props.character_interval;
			const t1 = t0 + this.props.character_duration;
			const cu = MUTIL.unlerp(t, t0, t1);
			const cun = MUTIL.clamp(cu, 0, 1);
			const blur = MUTIL.lerp(Math.pow(cun, 1.0), 15, 0);
			const opacity = cun;
			const style = {
				filter: "blur(" + blur.toFixed(1) + "px)",
				opacity,
			}
			xs.push(
				<span key={i} style={style}>{characters[i]}</span>
			);
		}
		return xs;
	}
}

function FancyNumberBlur(props) {
	const value_render = props.unit ? I18N.intval_unit(props.value, props.unit) : I18N.intval(props.value);
	const characters = props.render_static(value_render);
	const character_duration = coalesce(props.character_duration, 1.35);
	const character_interval = coalesce(props.character_interval, 0.045);
	const total_duration = characters.length * character_duration + character_interval;
	const iprops = {
		...props,
		character_duration,
		character_interval,
		total_duration,
		characters,
	};
	return <FancyNumberBlurAnim {...iprops}/>;
}

class FancyNumberCountAnim extends Component {
	constructor(props) {
		super(props);
		this.state = { u: 0 };
	}

	componentDidMount() {
		this.animator = new Animator({
			speed: 1/this.props.duration,
			callback: (u) => this.setState({u})
		});
	}

	componentWillUnmount() {
		if (this.animator) this.animator.kill();
	}

	render() {
		const v = I18N.intval(this.props.value * this.state.u);
		return <span>{v}</span>;
	}
}
function FancyNumberCount(props) {
	const duration = props.duration || 1.3;
	const iprops = {
		...props,
		duration,
	}
	return <FancyNumberCountAnim {...iprops}/>;
}

function FancyNumberInner(props) {
	const method = props.method || "blur";
	switch (method) {
	case "blur": return <FancyNumberBlur {...props}/>;
	case "count": return <FancyNumberCount {...props}/>;
	default: return <div>?</div>;
	}
}

function FancyNumber(props) {
	return <TraksConsumer><FancyNumberInner {...props}/></TraksConsumer>;
}

export default FancyNumber;



// WEBPACK FOOTER //
// ./src/c/FancyNumber.js